export const steps = [
    {
        target: 'body',
        content: `👋 Welcome to ManageEcom! Let's take a quick tour to help you get started with managing your online business across multiple marketplaces.`,
        placement: 'center',
    },
    {
        target: '.order-tab',
        content: `📊 This shows today's orders. Click here to view all your orders from connected channels like Amazon and Flipkart.`,
        placement: 'bottom'
    },
    {
        target: '.alert',
        content: `⚠️ Important alerts and setup reminders appear here. Complete the suggested steps to get your account fully operational.`,
        placement: 'bottom'
    },
]